import itemPurchaseThread from './components/itemPurchaseThread';
import mroInviteToRfq from './components/mroInviteToRfq';
import countrySelector from './components/countrySelector';

export default {
  search: {
    header: {
      title: 'Búsqueda',
      invite_button: 'Invitar a RFQ',
      info_request_button: '  Solicitar Información',
    },
    filters_bar: {
      search_placeholder: 'Buscar por palabras claves',
      country_filter: 'Seleccionar País',
      category_placeholder: 'Buscar categoría',
      org_placeholder: 'Buscar organización',
      filter_counter: {
        cp: {
          acronym: 'CP ',
          content: 'similitudes con items del cátalogo público',
        },
        mdm: {
          acronym: 'MDM ',
          content: 'similitudes con items de tu maestro de materiales',
        },
        cr: {
          acronym: 'CR ',
          content: 'similitudes con items del cátalogo cross reference',
        },
      },
    },
    result_table: {
      selection: 'Seleccionar Proveedor',
      provider: 'Nombre del Proveedor',
      tax_provider: 'RUT Proveedor',
      description: 'Descripción del Item',
      class: 'Clase',
      price: 'Precio Unitario',
      match: {
        label: 'MATCH',
        match1: 'Muy Alto',
        match2: 'Alto',
        match3: 'Medio',
        match4: 'Bajo',
      },
      expand: {
        manufacturer: 'Fabricante',
        part_number: 'Número de parte',
        action: {
          label: 'Acción',
          search: 'Buscar',
        },
      },
      scope: {
        item2: 'P/N:',
        item3: 'Código interno:',
        item4: 'N° equivalencias:',
        item5: 'Centros:',
      },
      see: 'Ver',
      erpCode: 'Código ERP',
      itemName: 'Nombre del Item',
    },
    script: {
      components: {
        ...itemPurchaseThread,
        ...mroInviteToRfq,
        ...countrySelector,
      },
      copySuccessSku: {
        title: 'Código interno',
        message: 'Copiado correctamente',
      },
      copyErrorSku: {
        title: 'Código interno',
        message: 'No se ha podido copiar',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/cat4mro/search.js